import { AnyAction } from 'redux';
import { useDispatch } from 'react-redux';
import { useElementIndex, ElementType } from '../../../contexts';
import { changeValue } from '../../../actions';

export const useOnChangeValue = () => {
  const dispatch = useDispatch();
  const requirementIndex = useElementIndex(ElementType.Requirement);
  const criteriaIndex = useElementIndex(ElementType.Criteria);
  const conditionIndex = useElementIndex(ElementType.Condition);

  return (value: string | string[]) => {
    const property = Array.isArray(value) ? 'values' : 'value';
    dispatch(
      changeValue(value, criteriaIndex, requirementIndex, conditionIndex, property) as AnyAction,
    );
  };
};
